import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ShippingCodeDto } from '../../felles/APICalls_NE01';

interface NE01DeleteDialogProps {
  row: ShippingCodeDto | null;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Bekreftelse før transportøren fjernes fra en kode. Koden blir stående i listen, som i FORS. */
export default function NE01DeleteDialog({ row, isDeleting, onConfirm, onCancel }: NE01DeleteDialogProps) {
  return (
    <Dialog open={row !== null} onClose={isDeleting ? undefined : onCancel} aria-labelledby="ne01-delete-title">
      <DialogTitle id="ne01-delete-title">Slette forsendelseskode «{row?.code}»?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Transportøren «{row?.carrierName}» fjernes fra kode {row?.code}. Koden blir stående i listen uten transportør.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting}>
          Avbryt
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting} autoFocus>
          Slett
        </Button>
      </DialogActions>
    </Dialog>
  );
}
